import { Box, Grid, Stack, Typography } from "@mui/material";
import { colors, shadows } from "../source/source.styles";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import RemoveIcon from "@mui/icons-material/Remove";

const MetricCard = ({ title, value, subtitle, trend, trendValue, icon, iconBg, iconColor }) => {
  const getTrendIcon = () => {
    if (trend === "up") return <TrendingUpIcon sx={{ fontSize: 14 }} />;
    if (trend === "down") return <TrendingDownIcon sx={{ fontSize: 14 }} />;
    return <RemoveIcon sx={{ fontSize: 14 }} />;
  };

  const getTrendColor = () => {
    if (trend === "up") return colors.success;
    if (trend === "down") return colors.danger;
    return colors.textMuted;
  };

  return (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        borderRadius: 3,
        p: 3,
        border: `1px solid ${colors.borderLight}`,
        boxShadow: shadows.card,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          width: 48,
          height: 48,
          borderRadius: 2,
          bgcolor: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: iconColor,
        }}
      >
        {icon}
      </Box>

      {/* Title */}
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.5,
          color: colors.textMuted,
          textTransform: "uppercase",
          mb: 1,
        }}
      >
        {title}
      </Typography>

      {/* Value */}
      <Typography
        sx={{
          fontSize: 32,
          fontWeight: 700,
          color: colors.textPrimary,
          mb: 0.5,
          lineHeight: 1,
        }}
      >
        {value}
      </Typography>

      {/* Subtitle and Trend */}
      <Stack direction="row" alignItems="center" spacing={1} mt={1}>
        {trendValue && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{
              px: 1,
              py: 0.5,
              borderRadius: 1,
              bgcolor: trend === "up" ? "#ECFDF5" : trend === "down" ? "#FEF2F2" : colors.bgPrimary,
              color: getTrendColor(),
            }}
          >
            {getTrendIcon()}
            <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
              {trendValue}
            </Typography>
          </Stack>
        )}
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: colors.textSecondary,
          }}
        >
          {subtitle}
        </Typography>
      </Stack>
    </Box>
  );
};

const ConversionMetrics = ({ data }) => {
  return (
    <Grid container spacing={3}>
      {/* Primary Positive Metrics */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <MetricCard
          title="Overall Conversion Rate"
          value={`${data.conversionRate}%`}
          subtitle="vs last month"
          trend="up"
          trendValue={`+${data.conversionRateTrend}%`}
          icon={<TrendingUpIcon sx={{ fontSize: 24 }} />}
          iconBg="#F3E8FF"
          iconColor={colors.chartPurple}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <MetricCard
          title="Total Won Deals"
          value={data.totalWonDeals}
          subtitle="deals won"
          trend="up"
          trendValue={`+${data.totalWonDealsTrend}%`}
          icon={<TrendingUpIcon sx={{ fontSize: 24 }} />}
          iconBg="#ECFDF5"
          iconColor={colors.success}
        />
      </Grid>

      {/* Negative Metrics */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <MetricCard
          title="Overall Dropped Rate"
          value={`${data.overallDroppedRate}%`}
          subtitle="of all leads"
          trend="down"
          trendValue={data.overallDroppedRate > 10 ? "High" : null}
          icon={<TrendingDownIcon sx={{ fontSize: 24 }} />}
          iconBg="#FEE2E2"
          iconColor="#DC2626"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <MetricCard
          title="Total Dropped Leads"
          value={data.totalDropped}
          subtitle="leads dropped"
          trend="stable"
          trendValue={null}
          icon={<RemoveIcon sx={{ fontSize: 24 }} />}
          iconBg="#FEF2F2"
          iconColor={colors.danger}
        />
      </Grid>
    </Grid>
  );
};

export default ConversionMetrics;
